<app-menu-crud-panel-bot [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">

</app-menu-crud-panel-bot>